import TimeOffRequestEvent from './TimeOffRequestEvent';
import HolidayEvent from './HolidayEvent';
import BlockedDateEvent from './BlockedDateEvent';
import CelebrationEvent from './CelebrationEvent';

class CalendarEventFactory {
  constructor(event) {
    switch (event.extendedProps.type) {
      case 'time_off_request':
        return new TimeOffRequestEvent(event);
      case 'holiday':
        return new HolidayEvent(event);
      case 'blocked_date':
        return new BlockedDateEvent(event);
      case 'birthday':
      case 'anniversary':
      case 'first_day':
        return new CelebrationEvent(event);
      default:
        throw new Error(`Type ${event.extendedProps.type} is not supported.`);
    }
  }
}

export default CalendarEventFactory;
